import { doc, getDoc, updateDoc} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { db } from "../../../../Config/Firebase/config";
import parse from 'html-react-parser';
import "./blogDetails.css";
import { useNavigate, useParams } from "react-router-dom";
import { useUserAuth } from "../../../../context/userAuthContext";
import blogIcons from './../../blogIcon';
import ShareModal from "../Share/shareModal";
import Comment from "../Comment/comment";


const BlogDetails = () => {
  const navigate = useNavigate();
  const {user} = useUserAuth();
  const {blogId} = useParams();
  const [loading, setLoading] = useState(true);
  const [blog, setBlog] = useState(null);
  const [blogLiked, setBlogLiked] = useState(false);
  const [copyURL, setCopyURL] = useState('');
  const currentURL = `https://chandanmahato.com.np/blog/${blogId}`
  
  const handleGoToBlog = () => {
    navigate("/blog");
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleShareBlog = () => {
    openModal();
  };

   const handleLikedBlog = async (data) => {
    const blogRef = doc(db, "blogdata", blogId);
    try {
      if (!user) {
        return toast.info('Signin Required');
      }
      const updatedBlogData = {
        ...data,
        likes: {
          ...data.likes,
          count: data.likes.count + (data.likes[user.uid] ? -1 : 1),
          [user.uid]: !data.likes[user.uid]
        }
      };
      await updateDoc(blogRef, updatedBlogData);
      setBlog((prevBlog) => ({ ...prevBlog, ...updatedBlogData }));
      setBlogLiked(!data.likes[user.uid]);
       !data.likes[user.uid] ? toast.success("Thanks for the Like.") : toast.info("Sorry for the disappointment");
    } catch (error) {
        toast.error("Error updating blog");
    }
  }


  useEffect(() => {
    const blogRef = doc(db, "blogdata", blogId);
    const getBlogData = async () => {
      try {
        const docSnap = await getDoc(blogRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setBlog({ ...data, id: docSnap.id });
          setBlogLiked(user && !!data.likes[user.uid]);
        } else {
          toast.error("Blog Not Found");
        }
      } catch (error) {
        toast.error("Could not Load Blog Data");
      } finally {
        setLoading(false);
      }
    };
    getBlogData();
  }, [blogId, user]);

  return (
      <React.Fragment>
        <section className="blogDetails section">
          <div className="blogDetails-container">
            <div className="row">
              <div className="section-title padd-15">
                <h2 onClick={handleGoToBlog}><p className="backBtn">Blog List {blogIcons.back} </p></h2>
              </div>
            </div>

            {isModalOpen && (
                <ShareModal
                  isOpen={isModalOpen}
                  closeModal={closeModal}
                  blogTitle={blog.title}
                  blogSummary={blog.summary}
                  URL={currentURL}
                  copyURL = {copyURL}
                  setCopyURL = {setCopyURL}
                />
              )}

            { loading ?(
              <h3>Loading...</h3>
            ): (blog ? (
              <div className="blogDetails-content">
              <div className="row">
                <div className="blogDetails-item padd-15" key={blog.id}>
                    <div className="blogDetails-item-inner">
                      <div className="top-section">
                        <div className="category-time-date">
                          <div className="category tooltip" tooltip="Category">
                            <p className="category-icon">{blogIcons.categoryIcon}</p>
                            <p className="category-text">{blog.category['title']}</p>
                          </div>
                          <p className="timeRead tooltip" tooltip="Time to Read">{blog.timeRead}</p>
                          <p className="date tooltip" tooltip="Published Date">{blog.date}</p>
                        </div>
                        <div className="like-share">
                          <p 
                            className="like-icon tooltip" 
                            tooltip="Like" 
                            onClick={() => handleLikedBlog(blog)}
                          >
                            {blogLiked ? blogIcons.liked : blogIcons.like}
                            <span className="like-count">
                              {blog.likes['count']}
                            </span>
                          </p>
                          <p className="share-icon tooltip"
                            tooltip="Share"
                            onClick={() => handleShareBlog(blog)}
                          >
                            {blogIcons.share}
                          </p>
                        </div>
                      </div>
                      <div className="blog-content">{parse(blog.blogContent)}</div>
                    </div>
                  </div>
              </div>
            </div>
            ): <button className="btn" onClick={handleGoToBlog}>Go To Blog List Page</button>)}
          </div>
        </section>
        {
          blog && 
          <Comment 
            user= {user}
            blogId={blogId}
            blog= {blog}
            setBlog={setBlog}
          />
        }
      </React.Fragment>
  );
};

export default BlogDetails;
